module.exports = __webpack_public_path__ + "img/Customer-info.4c4fa35b.svg";